import trekronorTheme from "../../../trekronorTheme";
export default {
  ...trekronorTheme,
  colors: {
    ...trekronorTheme.colors,
    senary1: trekronorTheme.colors.tertiary1
  },
  fonts: {
    ...trekronorTheme.fonts,
    serif: trekronorTheme.fonts.swedbankHeadline
  },
  fontWeights: {
    ...trekronorTheme.fontWeights,

    semibold: trekronorTheme.fontWeights.black
  }
};
